import styled from 'styled-components'

export const LoaderWrapper = styled.div`
  background-color: ${({ theme }) => theme.colors.white.s100};
  bottom: 0;
  height: 100vh;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
`
